import React, { Component } from "react";
import StatusPayment from "./StatusPayment";
import BoxInfos from "../common/BoxInfos";
import { formatPrice, getHoursDateGMT } from "../../utils";

export default class StatusPix extends Component {
  constructor(props) {
    super(props);
    this.barCode = React.createRef();
    this.isImageURLValid(this.props.purchase.payment.qrcode_url);

    this.state = {
      textButtonCopied: "Copiar código",
      isURLValid: false,
    };
  }

  componentDidMount() {
    if (window.location.hash === '#btncopyqrcode') {
      setTimeout(() => {
        const element = document.getElementById('btncopyqrcode');
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });
        }
      }, 100);
    }
  }

  copyBarcode = () => {
    const copyText = this.barCode.current;
    var range = document.createRange();
    range.selectNode(copyText);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    this.setState({ textButtonCopied: "Copiado!" });
  };

  urlImageValidationHandler = (path) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = path;
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  };

  isImageURLValid = (url) => {
    this.urlImageValidationHandler(url).then((result) => {
      this.setState({ isURLValid: result });
    });
  };

  render() {
    const { purchase } = this.props;

    if (purchase.payment_status === 'Aprovado') {
      return (
        <React.Fragment>
          <div className="title-box">Pagamentos</div>
          <div className="box payment">
            <div className="header-box credit"></div>
            <div className="body-box">
              <div className="credit">
                <strong>Pagamento</strong>
                <strong>PIX</strong>
                <div className="brand" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <img src="/assets/images/pagamento/pix.svg" alt="PIX" style={{ width: '40px', flexShrink: 0 }} />
                  <div className="infos-credit" style={{ display: 'flex', alignItems: 'center' }}>
                    <b>Valor pago:</b>&nbsp;R$ {formatPrice(purchase.price)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return (
      <StatusPayment purchase={purchase}>
        <div className="pix">
          <BoxInfos image="/assets/images/icons/alert.svg" altIcon="icon-warning" theme="warning">
            Siga as intruções de pagamento abaixo para prosseguir com a emissão da sua apólice. Faça o pagamento o mais rápido possível e garanta seu seguro.
          </BoxInfos>

          <div className="pix-rules">
            <b>1 -</b> No aplicativo do seu banco, localize a opção PIX e selecione Pagar.
          </div>

          <div className="pix-rules">
            {purchase.payment.qrcode_url ? (
              <React.Fragment>
                <div className="desktop">
                  {this.state.isURLValid ? (
                    <React.Fragment>
                      <b>2 -</b> Escolha a opção <b>Ler QR Code</b> e aproxime a câmera do seu celular ou então a opção <b>Pix Copia e Cola</b> e
                      copie a chave abaixo.
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <b>2 -</b> Escolha a opção <b>Pix Copia e Cola</b> e copie a chave abaixo.
                    </React.Fragment>
                  )}
                </div>

                <div className="mobile">
                  <b>2 -</b>Escolha a opção <b>Pix Copia e Cola</b> e copie a chave abaixo.
                </div>
                {this.state.isURLValid && (
                  <React.Fragment>
                    <div className="box-pix-payment desktop">
                      <div className="title"> Ler QR Code</div>
                      <div className="subtitle">Aproxime a câmera do seu celular para ler a imagem</div>
                      <img src={purchase.payment.qrcode_url} alt="Qrcode pagamento pix" />
                    </div>
                    <div className="separation desktop">OU</div>
                  </React.Fragment>
                )}

                <div className="box-pix-payment">
                  <div className="title">Pix Copia e Cola</div>
                  <div className="subtitle">
                    Copie o código e cole no aplicativo do seu banco. <br /> <b>Lembre-se, não se trata de um boleto bancário.</b>
                  </div>
                  <div>
                    <input type="text" value={purchase.payment.pix_code} className="input-code" ref={this.barCode} />
                  </div>
                  <div>
                    <button className="button-copy" onClick={this.copyBarcode} id="btncopyqrcode">
                      {this.state.textButtonCopied}
                    </button>
                  </div>
                  <div className="help-pix">Você tem até {getHoursDateGMT(purchase.payment.deadline)} para efetuar o pagamento.</div>
                </div>
              </React.Fragment>
            ) : (
              <div>
                <b>2 -</b> Veja as instruções de pagamento que <b>foram enviadas para o seu e-mail</b>.
              </div>
            )}
          </div>
          <div className="pix-rules">
            <b>3 -</b> Confira os dados e efetue o pagamento:
            <br /> <b>Valor:</b> R$ {formatPrice(purchase.price)}
            <br /> <b>Favorecido:</b> PayMee Brasil Serviços de Pagamento SA
          </div>

          <div className="pix-rules">
            <b>4 - Agora é só aguardar!</b> Acompanhe no seu e-mail o status e as atualizações do seu pedido.
          </div>

          <BoxInfos image="/assets/images/icons/phone.svg" altIcon="icon-phone" theme="success pos-payment">
            Entre em contato em um dos nosso canais de atendimento caso não receba o e-mail de compra aprovada em até 2hs após o pagamento.
          </BoxInfos>
        </div>
      </StatusPayment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusPix.jsx